module.exports = __webpack_public_path__ + "img/check-circle.33261ca7.svg";